import { inject, injectable } from "inversify";

import Dependent from "@model/Dependent";
import AssociatedShowViewModel from "@vm/Show/AssociatedShowViewModel";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class DependentShowVM extends AssociatedShowViewModel<Dependent, AssociatedRepository<Dependent>> {
  constructor(@inject(TYPES.DependentRepository) repository: AssociatedRepository<Dependent>) {
    super(Dependent, repository);
  }
}
